import { createSelector } from "reselect";

const getCustomerProfile = state => state.data.profile;
const getOrder = state => state.data.order;

export const getDeliveryAddress = order =>
  order.orderForm.customer.customer_delivery_address;
export const getInvoiceAddress = order =>
  order.orderForm.customer.customer_invoice_address;
export const getPaymentMethod = order => order.paymentMethod;

export default createSelector(
  [getCustomerProfile, getOrder],
  (profile, order) => {
    if (profile && order.orderForm)
      return {
        profile,
        deliveryAddress: getDeliveryAddress(order),
        invoiceAddress: getInvoiceAddress(order),
        paymentMethod: getPaymentMethod(order),
      };
    return null;
  }
);



// WEBPACK FOOTER //
// ../shop_main/selector/payment.js